module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-desktop-75d0277c78a18372686909c36211e50f.jpg";